/* ─── Шрифты (self-hosted: игра обязана работать офлайн) ────────────────── */

@font-face {
  font-family: "Russo One";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/russo-one-cyrillic.woff2") format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

@font-face {
  font-family: "Russo One";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/russo-one-latin.woff2") format("woff2");
  unicode-range:
    U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400 800;
  font-display: swap;
  src: url("/fonts/manrope-cyrillic.woff2") format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400 800;
  font-display: swap;
  src: url("/fonts/manrope-latin.woff2") format("woff2");
  unicode-range:
    U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* ─── Токены ───────────────────────────────────────────────────────────────
   «Спортзал»: глубокий синий чернильный + один коралловый акцент. Дисплейный
   шрифт — табло и заголовки, текстовый — всё остальное. Радиусы маленькие,
   пилюль нет: скошенные углы оставлены только главным CTA и лентам. */

.game {
  --ink: #16324f;
  --ink-70: rgba(22, 50, 79, 0.7);
  --ink-50: rgba(22, 50, 79, 0.5);
  --ink-25: rgba(22, 50, 79, 0.25);
  --ink-12: rgba(22, 50, 79, 0.12);
  --accent: #e8492f;
  --accent-deep: #bc3620;
  --accent-soft: #ffd9d0;
  --gold: #e9a13b;
  --gold-deep: #a86f1c;
  --paper: #ffffff;
  --mist: #e9f1f9;
  --bad: #c0432f;
  --r-s: 8px;
  --r-m: 12px;
  --r-l: 18px;
  --font-display: "Russo One", "Manrope", system-ui, sans-serif;
  --font-text: "Manrope", system-ui, sans-serif;
  /* Типографика: одна шкала размеров на весь интерфейс. Два «голоса»:
     дисплейный (табло, ленты, заголовки) и текстовый (всё остальное). */
  --fs-xs: 0.8rem;
  --fs-s: 0.9rem;
  --fs-m: 1rem;
  --fs-l: 1.25rem;
  --fs-xl: 1.45rem;
  /* Ленты-бейджи — плотный трекинг, мелкие подписи — разрядка. */
  --ls-tag: 0.06em;
  --ls-label: 0.2em;

  position: fixed;
  inset: 0;
  /* Вырезы и «чёлки»: поле не заезжает под них, фон — заезжает. */
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)
    env(safe-area-inset-left);
  background: #d4e4f4;
  color: var(--ink);
  font-family: var(--font-text);
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}

.game__canvas {
  display: block;
  width: 100%;
  height: 100%;
  /* Иначе браузер забирает жест под скролл/зум и pointermove обрывается. */
  touch-action: none;
}

/* ─── HUD ────────────────────────────────────────────────────────────────── */

.game__hud {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 1.75rem);
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  pointer-events: none;
}

/* Табло: сплошная чернильная цифра — в референсе «23» без белой заливки и
   обводки, только лёгкая тень для глубины над светлым полом. */
.game__score {
  font-family: var(--font-display);
  font-size: 4rem;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--ink);
  text-shadow: 0 2px 6px rgba(22, 50, 79, 0.18);
}

/* Лента-параллелограмм «нижней трети трансляции» — осталась только для
   редкого уведомления («Открыт скин…»). Весь остальной HUD — пилюли
   (.game__pill) ниже, как в референсе. */
.game__tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  /* На оверлеях лента бывает и <p> — сбрасываем браузерный отступ. */
  margin: 0;
  padding: 0.3rem 1.1rem;
  clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
  background: var(--tag-bg, var(--ink));
  color: var(--tag-fg, var(--paper));
  /* drop-shadow, а не box-shadow: фильтр повторяет форму clip-path. */
  filter: drop-shadow(0 2px 0 rgba(22, 50, 79, 0.25));
  font-family: var(--font-display);
  font-size: var(--fs-s);
  letter-spacing: var(--ls-tag);
  text-transform: uppercase;
  font-variant-numeric: tabular-nums;
}

.game__tag--notice {
  --tag-bg: rgba(255, 255, 255, 0.92);
  --tag-fg: var(--accent-deep);
}

.game__bonus {
  color: var(--accent-soft);
}

/* ─── Пилюли ─────────────────────────────────────────────────────────────
   В отличие от .game__tag (параллелограмм «нижней трети трансляции»),
   пилюля — простой скруглённый прямоугольник: так в мокапах оформлены
   кошелёк, подзаголовок серии и бейджи активных баффов. Скошенные углы
   остаются только у CTA и ленты-уведомления — здесь, по спеке, их «строго
   нет», кроме одного акцентного подрезанного уголка у info-варианта. */
.game__pill {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  padding: 0.4rem 1.1rem 0.4rem 0.4rem;
  border-radius: var(--r-l);
  background: var(--pill-bg, var(--ink));
  color: var(--pill-fg, var(--paper));
  font-family: var(--font-text);
  font-weight: 700;
  font-size: var(--fs-s);
  font-variant-numeric: tabular-nums;
}

/* Без иконки слева — как у кошелька и подзаголовка серии — отступ симметричный. */
.game__pill--plain {
  padding: 0.45rem 1.1rem;
}

.game__pill--gold {
  --pill-bg: var(--gold);
  --pill-fg: var(--ink);
}

.game__pill--info {
  --pill-bg: #2d4467;
}

.game__pill--bad {
  --pill-bg: var(--bad);
}

/* Подзаголовок серии — широкая лента почти во всю ширину поля, как в
   референсе, а не узкая пилюля по размеру текста. */
.game__pill--wide {
  justify-content: center;
  min-width: min(85vw, 22rem);
}

/* Один подрезанный уголок — акцент, а не скос по всей плашке. */
.game__pill--cut {
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%);
}

.game__pill-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  flex-shrink: 0;
  border-radius: var(--r-s);
  background: rgba(255, 255, 255, 0.2);
}

.game__pill--gold .game__pill-icon {
  background: rgba(22, 50, 79, 0.14);
}

/* Активные баффы: та же пилюля, плюс место под полоску обратного отсчёта снизу. */
.game__pill--timed {
  position: relative;
  overflow: hidden;
  padding-bottom: 0.55rem;
}

/* Постоянный виджет кошелька — пилюля, закреплённая в углу экрана поверх
   любой фазы игры (кроме таблицы рекордов, у неё своя шапка). */
.game__wallet {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 1rem);
  right: calc(env(safe-area-inset-right) + 1rem);
  z-index: 1;
}

.game__perfect {
  font-family: var(--font-display);
  font-size: var(--fs-l);
  letter-spacing: var(--ls-tag);
  text-transform: uppercase;
  color: var(--accent);
  text-shadow:
    0 0 6px rgba(255, 255, 255, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.9);
  animation: game-pop 0.6s ease-out forwards;
}

@keyframes game-pop {
  0% {
    opacity: 0;
    transform: translateY(6px) scale(0.9);
  }
  25% {
    opacity: 1;
    transform: translateY(0) scale(1.05);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px) scale(1);
  }
}

/* ─── Оверлеи (меню / конец партии / таблица) ────────────────────────────── */

.game__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.9rem;
  padding: 1rem;
  text-align: center;
  /* Корт просвечивает, но глубже к краям — зал, а не плоская вуаль. */
  background: radial-gradient(
    ellipse 120% 90% at 50% 42%,
    rgba(214, 230, 246, 0.5) 0%,
    rgba(188, 211, 234, 0.78) 100%
  );
  backdrop-filter: blur(5px);
  animation: game-overlay-in 0.28s cubic-bezier(0.2, 0.9, 0.25, 1);
}

@keyframes game-overlay-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.game__logo {
  margin: 0;
  line-height: 0;
  filter: drop-shadow(0 3px 0 rgba(22, 50, 79, 0.2));
}

/* Шапка меню/результата: звук слева, лучший счёт по центру — кошелёк
   справа рисует отдельный .game__wallet, общий для всех фаз игры. Текст
   центрирован по всей ширине бара, кнопка — абсолютно поверх его левого края. */
.game__top-bar {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 1rem);
  left: calc(env(safe-area-inset-left) + 1rem);
  right: calc(env(safe-area-inset-right) + 1rem);
  display: flex;
  align-items: center;
  justify-content: center;
}

.game__header-best {
  margin: 0;
  font-size: var(--fs-s);
  font-weight: 700;
  color: var(--ink);
}

/* Мелкая подпись-разрядка («СЧЁТ», «СКИН», «РЕКОРД»): везде одинаковая. */
.game__label {
  margin: 0 0 -0.4rem;
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  color: var(--ink-50);
}

.game__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 5.5rem;
  line-height: 1.05;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}

.game__title[data-record="true"] {
  color: var(--accent);
}

.game__record {
  margin: 0;
  padding: 0.35rem 1.2rem;
  clip-path: polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%);
  background: var(--accent);
  color: var(--paper);
  font-family: var(--font-display);
  font-size: var(--fs-m);
  letter-spacing: var(--ls-tag);
  text-transform: uppercase;
  transform: rotate(-1.5deg);
  animation: game-record-in 0.45s cubic-bezier(0.2, 1.4, 0.4, 1) 0.15s backwards;
}

@keyframes game-record-in {
  from {
    opacity: 0;
    transform: rotate(-1.5deg) scale(0.6);
  }
  to {
    opacity: 1;
    transform: rotate(-1.5deg) scale(1);
  }
}

.game__subtitle {
  margin: 0;
  max-width: 19rem;
  font-size: var(--fs-m);
  font-weight: 600;
  line-height: 1.45;
  color: var(--ink-70);
}

/* ─── Кнопки ─────────────────────────────────────────────────────────────── */

/* Главная CTA: скошенные углы и жёсткая «нажимная» тень — спортивный стиль. */
.game__button {
  margin-top: 0.4rem;
  min-width: 12rem;
  padding: 1rem 2.4rem;
  border: none;
  clip-path: polygon(
    0 0,
    calc(100% - 16px) 0,
    100% 16px,
    100% 100%,
    16px 100%,
    0 calc(100% - 16px)
  );
  background: linear-gradient(180deg, #f0563c, var(--accent) 55%, #d94026);
  color: var(--paper);
  filter: drop-shadow(0 4px 0 var(--accent-deep));
  font-family: var(--font-display);
  font-size: var(--fs-l);
  letter-spacing: var(--ls-tag);
  text-transform: uppercase;
  cursor: pointer;
  transition:
    transform 0.08s ease-out,
    filter 0.08s ease-out;
}

.game__button:active:not(:disabled) {
  transform: translateY(3px);
  filter: drop-shadow(0 1px 0 var(--accent-deep));
}

.game__button:disabled {
  background: var(--ink-25);
  filter: none;
  cursor: default;
}

/* clip-path срезает outline, поэтому фокус — свечение поверх формы. */
.game__button:focus-visible {
  filter: drop-shadow(0 4px 0 var(--accent-deep)) drop-shadow(0 0 7px rgba(22, 50, 79, 0.7));
  outline: none;
}

.game__secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.5rem;
  border: 2px solid var(--ink);
  border-radius: var(--r-m);
  background: var(--paper);
  color: var(--ink);
  box-shadow: 0 3px 0 var(--ink-25);
  font: inherit;
  font-weight: 800;
  font-size: var(--fs-s);
  cursor: pointer;
  transition:
    transform 0.08s ease-out,
    box-shadow 0.08s ease-out;
}

.game__secondary:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 var(--ink-25);
}

.game__secondary:focus-visible {
  outline: 3px solid var(--ink);
  outline-offset: 2px;
}

/* Иконка-кнопка звука: тёмный скруглённый квадрат, как в референсе —
   не круг и не полупрозрачная обводка. */
.game__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border: none;
  border-radius: var(--r-m);
  background: var(--ink);
  color: var(--paper);
  cursor: pointer;
  transition:
    transform 0.08s ease-out,
    background 0.15s ease-out;
}

.game__icon-btn:hover {
  background: #1d3c5e;
}

.game__icon-btn:active {
  transform: scale(0.92);
}

.game__icon-btn:focus-visible {
  outline: 3px solid var(--ink);
  outline-offset: 2px;
}

.game__icon-btn[data-off="true"] {
  background: var(--ink-25);
}

/* Внутри .game__top-bar: прижата к левому краю, текст по центру бара. */
.game__sound {
  position: absolute;
  left: 0;
}

/* ─── Скины ──────────────────────────────────────────────────────────────── */

.game__skins {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin: 0.5rem 0 0;
  padding: 0;
  border: none;
}

.game__skins-title {
  width: 100%;
  margin-bottom: 0.4rem;
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  text-align: center;
  color: var(--ink-50);
}

.game__skin {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.4rem 0.85rem 0.4rem 0.45rem;
  border: 2px solid var(--ink-12);
  border-radius: var(--r-m);
  background: rgba(255, 255, 255, 0.7);
  color: inherit;
  font: inherit;
  font-weight: 700;
  font-size: var(--fs-s);
  cursor: pointer;
}

.game__skin[aria-pressed="true"] {
  border-color: var(--ink);
  background: var(--paper);
  box-shadow: 0 2px 0 var(--ink-25);
}

.game__skin:disabled {
  opacity: 0.5;
  cursor: default;
}

.game__swatch {
  width: 1.1rem;
  height: 1.1rem;
  border: 3px solid;
  border-radius: 50%;
}

/* ─── Ник ─────────────────────────────────────────────────────────────── */

.nickname {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  width: 100%;
  max-width: 21rem;
}

.nickname__label {
  font-size: var(--fs-s);
  font-weight: 700;
  color: var(--ink-70);
}

.nickname__row {
  display: flex;
  gap: 0.45rem;
  width: 100%;
}

.nickname__input {
  flex: 1;
  min-width: 0;
  padding: 0.6rem 0.9rem;
  border: 2px solid var(--ink-25);
  border-radius: var(--r-m);
  background: var(--paper);
  color: inherit;
  /* 16px и больше: иначе iOS Safari зумит страницу при фокусе. */
  font: inherit;
  font-size: 1rem;
}

.nickname__input:focus-visible {
  outline: none;
  border-color: var(--ink);
  box-shadow: 0 0 0 3px var(--ink-12);
}

.nickname__input[aria-invalid="true"] {
  border-color: var(--bad);
}

.nickname__submit {
  padding: 0.6rem 1.1rem;
  border: none;
  border-radius: var(--r-m);
  background: var(--ink);
  color: var(--paper);
  box-shadow: 0 3px 0 rgba(22, 50, 79, 0.35);
  font: inherit;
  font-weight: 800;
  cursor: pointer;
  transition:
    transform 0.08s ease-out,
    box-shadow 0.08s ease-out;
}

.nickname__submit:active:not(:disabled) {
  transform: translateY(2px);
  box-shadow: 0 1px 0 rgba(22, 50, 79, 0.35);
}

.nickname__submit:disabled {
  opacity: 0.5;
}

.nickname__error {
  margin: 0;
  font-size: var(--fs-xs);
  font-weight: 600;
  color: var(--bad);
}

/* ─── Таблица рекордов ─────────────────────────────────────────────────── */

.board {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  width: 100%;
  max-width: 24rem;
  max-height: 100%;
  padding: 1.1rem;
  border: 2px solid var(--ink-12);
  border-radius: var(--r-l);
  background: var(--paper);
  box-shadow:
    0 18px 40px -12px rgba(22, 50, 79, 0.35),
    0 2px 0 var(--ink-12);
  text-align: left;
}

.board__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.board__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--fs-xl);
  letter-spacing: 0.03em;
  color: var(--ink);
}

.board__close,
.board__link {
  border: none;
  background: none;
  color: var(--ink);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.board__close {
  padding: 0.35rem 0.7rem;
  border: 2px solid var(--ink-12);
  border-radius: var(--r-s);
  font-size: var(--fs-xs);
}

.board__close:hover {
  border-color: var(--ink-25);
  background: var(--mist);
}

.board__link {
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.board__tabs {
  display: flex;
  gap: 0.3rem;
  padding: 0.3rem;
  border-radius: var(--r-m);
  background: var(--mist);
}

.board__tab {
  flex: 1;
  padding: 0.45rem 0.5rem;
  border: none;
  border-radius: var(--r-s);
  background: transparent;
  color: var(--ink-70);
  font: inherit;
  font-size: var(--fs-s);
  font-weight: 700;
  cursor: pointer;
}

.board__tab[aria-selected="true"] {
  background: var(--ink);
  color: var(--paper);
  box-shadow: 0 2px 0 rgba(22, 50, 79, 0.3);
}

.board__body {
  flex: 1;
  min-height: 8rem;
  overflow-y: auto;
}

.board__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.board__row {
  display: grid;
  grid-template-columns: 2.5rem 1fr auto;
  align-items: center;
  padding: 0.5rem 0.65rem;
  border-radius: var(--r-s);
  font-variant-numeric: tabular-nums;
}

.board__row:nth-child(odd) {
  background: var(--mist);
}

.board__row[data-me="true"] {
  background: var(--accent);
  color: var(--paper);
  font-weight: 700;
}

.board__rank {
  font-family: var(--font-display);
  font-size: var(--fs-s);
  color: var(--ink-50);
}

.board__row[data-me="true"] .board__rank {
  color: var(--accent-soft);
}

.board__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.board__score {
  font-family: var(--font-display);
  font-size: var(--fs-m);
}

.board__note {
  margin: 0;
  font-size: var(--fs-s);
  text-align: center;
  color: var(--ink-70);
}

.board__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

/* ─── Бонусы ───────────────────────────────────────────────────────────── */

.game__effects {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.25rem;
  padding: 0 1rem;
}

/* Полоска оставшегося времени: CSS-анимация, чтобы React не тикал каждый кадр.
   Пилюли теперь всегда цветные (ink/gold/info/bad), поэтому полоска —
   универсальный полупрозрачный белый оверлей, кроме светлого gold-варианта,
   где белый терялся бы — там тёмный. */
.game__effect-timer {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: rgba(255, 255, 255, 0.65);
  transform-origin: left;
  animation: game-countdown linear forwards;
}

.game__pill--gold .game__effect-timer {
  background: rgba(22, 50, 79, 0.35);
}

@keyframes game-countdown {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .game__perfect,
  .game__overlay,
  .game__record {
    animation-duration: 0.01s;
  }

  .game__button,
  .game__secondary,
  .nickname__submit,
  .game__icon-btn {
    transition: none;
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
